import { render } from "./MobileChoose.vue?vue&type=template&id=004832d2"
import script from "./MobileChoose.vue?vue&type=script&lang=js"
export * from "./MobileChoose.vue?vue&type=script&lang=js"

import "./MobileChoose.vue?vue&type=style&index=0&id=004832d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__